import {ChangeDetectionStrategy, Component, input, signal, ViewEncapsulation} from '@angular/core';
import {ElementToggleEnum} from '../../enums/CssClassEnums';
import {RoutesEnums} from '../../enums/RoutesEnums';
import {DLPageTypeEnum} from '../../enums/DataLayerEnums';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SidebarComponent {
  isCustomer = input<boolean>(false);
  moduleName = input<RoutesEnums>(null);
  isAdVisible = input<boolean>(true);
  isPuffVisible = input<boolean>(true);
  // loadDoktorseRecept = input<boolean>(false);
  cpruTypes = input<number[]>(null);
  serviceTypes = input<number[]>(null);
  places = input<number[]>(null);
  excludedIds = input<number[]>([]);
  pageType = input<DLPageTypeEnum>(null);

  public ad1aReloadCallback: Function;
  public ad2aReloadCallback: Function;
  public isAdPlaceholderActive = signal<boolean>(true);
  private isBanner1aLoaded = signal<boolean>(false);
  private isBanner2aLoaded = signal<boolean>(false);

  constructor() {
    this.ad1aReloadCallback = (cssClass: string) => this.onBanner1aReload(cssClass);
    this.ad2aReloadCallback = (cssClass: string) => this.onBanner2aReload(cssClass);
  }

  private onBanner1aReload(cssClass: string): void {
    this.isBanner1aLoaded.set(cssClass === ElementToggleEnum.ACTIVE);
    this.updatePlaceholderVisibility();
  }

  private onBanner2aReload(cssClass: string): void {
    this.isBanner2aLoaded.set(cssClass === ElementToggleEnum.ACTIVE);
    this.updatePlaceholderVisibility();
  }

  private updatePlaceholderVisibility(): void {
    this.isAdPlaceholderActive.set(this.isBanner1aLoaded() === false && this.isBanner2aLoaded() === false);
  }
}
